import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Bold, Paragraph, Subtitle } from '@components/Styled';
import { Notification as NotificationContainer } from '../NotificationCenter.style';
const AutomaticInvoicingRestored = (props) => {
    const { notification } = props;
    return (_jsxs(NotificationContainer, { children: [_jsx(Subtitle, { level: "3", children: "Ya puedes liberar tus ingresos" }), _jsxs(Paragraph, { children: ["El servicio de facturaci\u00F3n autom\u00E1tica ya est\u00E1 disponible. Ve a", _jsx(Bold, { children: " Mis Propiedades" }), " e ", _jsx(Bold, { children: "ingresos por liberar " }), "para continuar."] }), _jsx(Paragraph, { color: "grayF", children: notification.getLocaleDate() })] }));
};
export default AutomaticInvoicingRestored;
